export enum HabilitationChoice {
  APPROBATION = 'APPROBATION',
  REFUS = 'REFUS'
}